<div [class]="chart.ChartSize" *ngIf="chartData && chartData.length > 0">
  <canvas baseChart [data]="chartData" [labels]="chartLabels" [options]="chartOptions" [legend]="chartLegend"
    [colors]="chartColors" [chartType]="chart.ChartType" (chartClick)="navigateTo()"></canvas>
</div>